"use strict";Object.defineProperty(exports, "__esModule", {value: true});
var _peers = require('shared/selectors/peers');

 const selectCurrentPatientKey = (state) => state.currentPatient; exports.selectCurrentPatientKey = selectCurrentPatientKey

 const selectCurrentPatient = (state) => {
  const patientKey = exports.selectCurrentPatientKey.call(void 0, state)
  return patientKey ? _peers.selectPatientByKey.call(void 0, state, patientKey) : null
}; exports.selectCurrentPatient = selectCurrentPatient
